import { createEvent, createStore } from 'effector';
import { effectorStartEvent } from '@nx-frontend/shared/store/client-side';
import {
  PortalServiceDnsRecordDto,
  PortalServicePortalExtendedDtoCnameStatusEnum,
  PortalServicePortalExtendedDtoStatusEnum,
} from '@nx-frontend/shared/types';

export interface DnsState {
  status: PortalServicePortalExtendedDtoStatusEnum;
  createdAt: number | null;
  cnameStatus: PortalServicePortalExtendedDtoCnameStatusEnum;
  cnameValue: string;
  dnsRecords?: PortalServiceDnsRecordDto[];
}

export const initialDnsState: DnsState = {
  status: PortalServicePortalExtendedDtoStatusEnum.Ready,
  createdAt: null,
  cnameStatus: PortalServicePortalExtendedDtoCnameStatusEnum.NA,
  cnameValue: '',
  dnsRecords: [],
};

export const updateDnsEvent = createEvent<DnsState>();

export const $dns = createStore(initialDnsState)
  .on(effectorStartEvent, (state) => state)
  .on(updateDnsEvent, (state, data) => {
    return {
      ...state,
      ...data,
    };
  });
export const $dnsRecords = $dns.map((state) => state.dnsRecords);
